import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { applicationAPI, adPlatformAPI, adPlacementAPI, adAnalyticsAPI, BASE_URL } from '../services/api';
import Icon from '../components/Icon';

const C = {
  page: { width: '100%' },
  back: { display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', color: '#4f46e5', fontSize: '13px', fontWeight: 600, cursor: 'pointer', padding: 0, marginBottom: '14px' },
  head: { display: 'flex', alignItems: 'center', gap: '16px', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: '20px 24px', marginBottom: '16px', flexWrap: 'wrap' },
  icon: { width: '56px', height: '56px', borderRadius: '14px', objectFit: 'cover', border: '1px solid #e2e8f0', backgroundColor: '#f8fafc' },
  iconPh: { width: '56px', height: '56px', borderRadius: '14px', backgroundColor: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4f46e5', fontWeight: 700, fontSize: 22 },
  hName: { fontSize: '20px', fontWeight: 700, color: '#1e293b', margin: 0 },
  hPkg: { fontSize: '13px', color: '#94a3b8', fontFamily: 'monospace', marginTop: 2 },
  badge: { padding: '3px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 600, backgroundColor: '#eef2ff', color: '#4f46e5' },
  statusBadge: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 600 },
  active: { backgroundColor: '#dcfce7', color: '#166534' },
  inactive: { backgroundColor: '#fee2e2', color: '#991b1b' },

  tabs: { display: 'flex', gap: '4px', marginBottom: '16px', borderBottom: '1px solid #e2e8f0' },
  tab: { padding: '10px 18px', fontSize: '14px', fontWeight: 600, color: '#64748b', background: 'none', border: 'none', borderBottom: '2px solid transparent', cursor: 'pointer' },
  tabActive: { color: '#4f46e5', borderBottomColor: '#4f46e5' },

  card: { backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', overflow: 'hidden' },
  toolbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderBottom: '1px solid #e2e8f0', gap: '12px', flexWrap: 'wrap' },
  addBtn: { padding: '9px 16px', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: '760px' },
  tableWrap: { overflowX: 'auto' },
  th: { padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
  td: { padding: '14px 16px', borderBottom: '1px solid #f1f5f9', fontSize: '14px', color: '#1e293b' },
  mono: { fontFamily: 'monospace', fontSize: '12px', color: '#475569' },
  iconBtn: { padding: '6px', border: '1px solid #e2e8f0', borderRadius: '6px', backgroundColor: '#fff', cursor: 'pointer', color: '#64748b', marginLeft: 6 },
  empty: { textAlign: 'center', padding: '60px 20px', color: '#64748b', fontSize: '14px' },
  errorBox: { padding: '12px 16px', backgroundColor: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', color: '#dc2626', margin: '16px', fontSize: '14px' },

  metricsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '12px', padding: '16px' },
  metric: { backgroundColor: '#f8fafc', borderRadius: '10px', padding: '16px' },
  metricVal: { fontSize: '22px', fontWeight: 700, color: '#1e293b' },
  metricLbl: { fontSize: '12px', color: '#64748b', marginTop: '4px' },
  dateRow: { display: 'flex', gap: '10px', alignItems: 'center', padding: '16px', borderBottom: '1px solid #e2e8f0', flexWrap: 'wrap' },
  dateInput: { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '13px' },

  modal: { position: 'fixed', inset: 0, backgroundColor: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' },
  modalContent: { backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '560px', maxHeight: '92vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' },
  modalHeader: { padding: '18px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  modalTitle: { fontSize: '18px', fontWeight: 700, color: '#1e293b', margin: 0 },
  modalBody: { padding: '20px 24px', overflowY: 'auto', flex: 1 },
  modalFooter: { padding: '14px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '10px', backgroundColor: '#fafbfc' },
  formGroup: { marginBottom: '14px' },
  label: { display: 'block', fontSize: '13px', fontWeight: 500, color: '#475569', marginBottom: '6px' },
  input: { width: '100%', padding: '10px 14px', border: '1px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
  twoCol: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  primaryButton: { padding: '10px 20px', backgroundColor: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer' },
  secondaryButton: { padding: '10px 20px', backgroundColor: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer' },
  closeBtn: { width: '32px', height: '32px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#64748b' },
};

const toAbsolute = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  return `${BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

const PLATFORM_TYPES = ['ADMOB', 'FACEBOOK', 'UNITY', 'IRONSOURCE', 'APPLOVIN', 'MINTEGRAL', 'VUNGLE', 'OTHER'];
const AD_TYPES = ['BANNER', 'INTERSTITIAL', 'REWARDED', 'NATIVE', 'APP_OPEN', 'REWARDED_INTERSTITIAL'];
const STATUSES = ['ACTIVE', 'INACTIVE', 'TESTING'];

export default function ApplicationDetail() {
  const { id } = useParams();
  const appId = parseInt(id);
  const navigate = useNavigate();

  const [app, setApp] = useState(null);
  const [tab, setTab] = useState('platforms');
  const [error, setError] = useState('');

  const loadApp = useCallback(async () => {
    try {
      const res = await applicationAPI.getById(appId);
      setApp(res.data?.data || null);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to load application');
    }
  }, [appId]);

  useEffect(() => { loadApp(); }, [loadApp]);

  return (
    <div style={C.page}>
      <button style={C.back} onClick={() => navigate('/applications')}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6" /></svg>
        Back to Applications
      </button>

      {error && <div style={C.errorBox}>{error}</div>}

      {app && (
        <div style={C.head}>
          {app.iconUrl
            ? <img src={toAbsolute(app.iconUrl)} alt="" style={C.icon} />
            : <div style={C.iconPh}>{(app.name || '?').charAt(0).toUpperCase()}</div>}
          <div style={{ flex: 1, minWidth: 200 }}>
            <h1 style={C.hName}>{app.name}</h1>
            <div style={C.hPkg}>{app.packageId}</div>
          </div>
          <span style={C.badge}>{app.store}</span>
          <span style={{ ...C.statusBadge, ...(app.status === 'ACTIVE' ? C.active : C.inactive) }}>{app.status}</span>
        </div>
      )}

      <div style={C.tabs}>
        {['platforms', 'placements', 'analytics'].map(t => (
          <button key={t} onClick={() => setTab(t)}
            style={{ ...C.tab, ...(tab === t ? C.tabActive : {}) }}>
            {t === 'platforms' ? 'Platforms' : t === 'placements' ? 'Placements' : 'Analytics'}
          </button>
        ))}
      </div>

      {tab === 'platforms' && <PlatformsTab appId={appId} />}
      {tab === 'placements' && <PlacementsTab appId={appId} />}
      {tab === 'analytics' && <AnalyticsTab appId={appId} />}
    </div>
  );
}

/* ───────────────── Platforms tab ───────────────── */
function PlatformsTab({ appId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [modal, setModal] = useState(null); // null | {} | row
  const blank = { platformId: '', name: '', type: 'ADMOB', status: 'ACTIVE', appId: '', apiKey: '', notes: '' };
  const [form, setForm] = useState(blank);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await adPlatformAPI.getAll({ applicationId: appId });
      setRows(Array.isArray(res.data) ? res.data : (res.data?.data || []));
    } catch (e) { setErr(e?.response?.data?.error || 'Failed to load platforms'); }
    finally { setLoading(false); }
  }, [appId]);
  useEffect(() => { load(); }, [load]);

  const openNew = () => { setForm(blank); setModal({}); };
  const openEdit = (r) => {
    setForm({ platformId: r.platformId, name: r.name, type: r.type, status: r.status, appId: r.appId || '', apiKey: r.apiKey || '', notes: r.notes || '' });
    setModal(r);
  };
  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setErr('');
    try {
      const payload = { ...form, applicationId: appId };
      if (modal && modal.id) await adPlatformAPI.update(modal.id, payload);
      else await adPlatformAPI.create(payload);
      setModal(null); load();
    } catch (e2) { setErr(e2?.response?.data?.error || 'Failed to save platform'); }
    finally { setSaving(false); }
  };
  const del = async (r) => {
    if (!window.confirm(`Delete platform "${r.name}"? Its placements are removed too.`)) return;
    try { await adPlatformAPI.delete(r.id); load(); }
    catch (e) { setErr(e?.response?.data?.error || 'Failed to delete'); }
  };

  return (
    <div style={C.card}>
      <div style={C.toolbar}>
        <strong style={{ fontSize: 14, color: '#1e293b' }}>Ad Platforms</strong>
        <button style={C.addBtn} onClick={openNew}>+ New Platform</button>
      </div>
      {err && <div style={C.errorBox}>{err}</div>}
      {loading ? <div style={C.empty}>Loading…</div>
        : rows.length === 0 ? <div style={C.empty}>No platforms for this app yet. Add one to start serving ads.</div>
          : (
            <div style={C.tableWrap}>
              <table style={C.table}>
                <thead><tr>
                  <th style={C.th}>Name</th><th style={C.th}>Platform ID</th><th style={C.th}>Type</th>
                  <th style={C.th}>Status</th><th style={C.th}>Placements</th><th style={{ ...C.th, textAlign: 'right' }}>Actions</th>
                </tr></thead>
                <tbody>
                  {rows.map(r => (
                    <tr key={r.id}>
                      <td style={{ ...C.td, fontWeight: 600 }}>{r.name}</td>
                      <td style={C.td}><span style={C.mono}>{r.platformId}</span></td>
                      <td style={C.td}><span style={C.badge}>{r.type}</span></td>
                      <td style={C.td}><span style={{ ...C.statusBadge, ...(r.status === 'ACTIVE' ? C.active : C.inactive) }}>{r.status}</span></td>
                      <td style={C.td}>{r._count?.placements ?? 0}</td>
                      <td style={{ ...C.td, textAlign: 'right' }}>
                        <button style={C.iconBtn} title="Edit" onClick={() => openEdit(r)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                        </button>
                        <button style={C.iconBtn} title="Delete" onClick={() => del(r)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6" /></svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

      {modal && (
        <div style={C.modal} onClick={() => setModal(null)}>
          <div style={C.modalContent} onClick={e => e.stopPropagation()}>
            <form onSubmit={save} style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <div style={C.modalHeader}>
                <h2 style={C.modalTitle}>{modal.id ? 'Edit Platform' : 'New Platform'}</h2>
                <button type="button" style={C.closeBtn} onClick={() => setModal(null)}><Icon name="close" size={16} /></button>
              </div>
              <div style={C.modalBody}>
                <div style={C.twoCol}>
                  <div style={C.formGroup}><label style={C.label}>Platform ID *</label>
                    <input style={C.input} value={form.platformId} required
                      onChange={e => setForm(f => ({ ...f, platformId: e.target.value }))} placeholder="admob_001" /></div>
                  <div style={C.formGroup}><label style={C.label}>Name *</label>
                    <input style={C.input} value={form.name} required
                      onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="AdMob" /></div>
                </div>
                <div style={C.twoCol}>
                  <div style={C.formGroup}><label style={C.label}>Type</label>
                    <select style={C.input} value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))}>
                      {PLATFORM_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select></div>
                  <div style={C.formGroup}><label style={C.label}>Status</label>
                    <select style={C.input} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                      {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select></div>
                </div>
                <div style={C.formGroup}><label style={C.label}>SDK App ID</label>
                  <input style={C.input} value={form.appId}
                    onChange={e => setForm(f => ({ ...f, appId: e.target.value }))} placeholder="ca-app-pub-..." /></div>
                <div style={C.formGroup}><label style={C.label}>API Key / Secret</label>
                  <input style={C.input} value={form.apiKey}
                    onChange={e => setForm(f => ({ ...f, apiKey: e.target.value }))} /></div>
                <div style={C.formGroup}><label style={C.label}>Notes</label>
                  <input style={C.input} value={form.notes}
                    onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} /></div>
              </div>
              <div style={C.modalFooter}>
                <button type="button" style={C.secondaryButton} onClick={() => setModal(null)}>Cancel</button>
                <button type="submit" style={C.primaryButton} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

/* ───────────────── Placements tab ───────────────── */
function PlacementsTab({ appId }) {
  const [rows, setRows] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [modal, setModal] = useState(null);
  // adUnitIds is always an array — at least one row is required. Default to
  // a single empty input so the form starts with one slot.
  const blank = { placementId: '', name: '', platformId: '', adUnitIds: [''], adType: 'BANNER', screenName: '', position: '', status: 'ACTIVE' };
  const [form, setForm] = useState(blank);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const [pl, pf] = await Promise.all([
        adPlacementAPI.getAll({ applicationId: appId }),
        adPlatformAPI.getAll({ applicationId: appId }),
      ]);
      setRows(Array.isArray(pl.data) ? pl.data : (pl.data?.data || []));
      setPlatforms(Array.isArray(pf.data) ? pf.data : (pf.data?.data || []));
    } catch (e) { setErr(e?.response?.data?.error || 'Failed to load placements'); }
    finally { setLoading(false); }
  }, [appId]);
  useEffect(() => { load(); }, [load]);

  const openNew = () => { setForm({ ...blank, platformId: platforms[0]?.id || '' }); setModal({}); };
  const openEdit = (r) => {
    // Server now returns adUnitIds as a parsed array; fall back to a
    // single-element list for legacy rows that only have adUnitId.
    const ids = Array.isArray(r.adUnitIds) && r.adUnitIds.length
      ? r.adUnitIds
      : (r.adUnitId ? [r.adUnitId] : ['']);
    setForm({ placementId: r.placementId, name: r.name, platformId: r.platformId, adUnitIds: ids, adType: r.adType, screenName: r.screenName, position: r.position || '', status: r.status });
    setModal(r);
  };
  const save = async (e) => {
    e.preventDefault();
    if (!form.platformId) { setErr('Select a platform (add one in the Platforms tab first).'); return; }
    // At least one non-empty ad unit ID is mandatory.
    const cleaned = (form.adUnitIds || []).map(s => (s || '').trim()).filter(Boolean);
    if (cleaned.length === 0) { setErr('At least one Ad Unit ID is required.'); return; }
    setSaving(true); setErr('');
    try {
      const payload = { ...form, platformId: parseInt(form.platformId), adUnitIds: cleaned };
      if (modal && modal.id) await adPlacementAPI.update(modal.id, payload);
      else await adPlacementAPI.create(payload);
      setModal(null); load();
    } catch (e2) { setErr(e2?.response?.data?.error || 'Failed to save placement'); }
    finally { setSaving(false); }
  };
  const del = async (r) => {
    if (!window.confirm(`Delete placement "${r.name}"?`)) return;
    try { await adPlacementAPI.delete(r.id); load(); }
    catch (e) { setErr(e?.response?.data?.error || 'Failed to delete'); }
  };

  return (
    <div style={C.card}>
      <div style={C.toolbar}>
        <strong style={{ fontSize: 14, color: '#1e293b' }}>Ad Placements</strong>
        <button style={C.addBtn} onClick={openNew}>+ New Placement</button>
      </div>
      {err && <div style={C.errorBox}>{err}</div>}
      {loading ? <div style={C.empty}>Loading…</div>
        : rows.length === 0 ? <div style={C.empty}>No placements yet. Create a platform, then add placements to it.</div>
          : (
            <div style={C.tableWrap}>
              <table style={C.table}>
                <thead><tr>
                  <th style={C.th}>Name</th><th style={C.th}>Placement ID</th><th style={C.th}>Platform</th>
                  <th style={C.th}>Type</th><th style={C.th}>Screen</th><th style={C.th}>Status</th>
                  <th style={{ ...C.th, textAlign: 'right' }}>Actions</th>
                </tr></thead>
                <tbody>
                  {rows.map(r => (
                    <tr key={r.id}>
                      <td style={{ ...C.td, fontWeight: 600 }}>{r.name}</td>
                      <td style={C.td}><span style={C.mono}>{r.placementId}</span></td>
                      <td style={C.td}>{r.platform?.name || '—'}</td>
                      <td style={C.td}><span style={C.badge}>{r.adType}</span></td>
                      <td style={C.td}>{r.screenName}</td>
                      <td style={C.td}><span style={{ ...C.statusBadge, ...(r.status === 'ACTIVE' ? C.active : C.inactive) }}>{r.status}</span></td>
                      <td style={{ ...C.td, textAlign: 'right' }}>
                        <button style={C.iconBtn} title="Edit" onClick={() => openEdit(r)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                        </button>
                        <button style={C.iconBtn} title="Delete" onClick={() => del(r)}>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6" /></svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

      {modal && (
        <div style={C.modal} onClick={() => setModal(null)}>
          <div style={C.modalContent} onClick={e => e.stopPropagation()}>
            <form onSubmit={save} style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
              <div style={C.modalHeader}>
                <h2 style={C.modalTitle}>{modal.id ? 'Edit Placement' : 'New Placement'}</h2>
                <button type="button" style={C.closeBtn} onClick={() => setModal(null)}><Icon name="close" size={16} /></button>
              </div>
              <div style={C.modalBody}>
                <div style={C.twoCol}>
                  <div style={C.formGroup}><label style={C.label}>Placement ID *</label>
                    <input style={C.input} value={form.placementId} required
                      onChange={e => setForm(f => ({ ...f, placementId: e.target.value }))} placeholder="home_banner_01" /></div>
                  <div style={C.formGroup}><label style={C.label}>Name *</label>
                    <input style={C.input} value={form.name} required
                      onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Home Banner" /></div>
                </div>
                <div style={C.formGroup}><label style={C.label}>Platform *</label>
                  <select style={C.input} value={form.platformId}
                    onChange={e => setForm(f => ({ ...f, platformId: e.target.value }))} required>
                    <option value="">Select platform</option>
                    {platforms.map(p => <option key={p.id} value={p.id}>{p.name} ({p.platformId})</option>)}
                  </select></div>
                <div style={C.formGroup}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <label style={{ ...C.label, marginBottom: 0 }}>Ad Unit ID *</label>
                    <button type="button"
                      onClick={() => setForm(f => ({ ...f, adUnitIds: [...(f.adUnitIds || []), ''] }))}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '5px 10px', border: '1px solid #c7d2fe', borderRadius: '6px', background: '#eef2ff', color: '#4f46e5', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                      Add
                    </button>
                  </div>
                  {(form.adUnitIds || ['']).map((v, idx) => {
                    const canDelete = (form.adUnitIds || []).length > 1;
                    return (
                      <div key={idx} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
                        <input
                          style={{ ...C.input, flex: 1 }}
                          value={v}
                          required={idx === 0}
                          onChange={e => setForm(f => {
                            const arr = [...(f.adUnitIds || [])];
                            arr[idx] = e.target.value;
                            return { ...f, adUnitIds: arr };
                          })}
                          placeholder="ca-app-pub-.../..."
                        />
                        <button
                          type="button"
                          title={canDelete ? 'Delete this ad unit' : 'At least one ad unit ID is required'}
                          disabled={!canDelete}
                          onClick={() => setForm(f => {
                            const arr = (f.adUnitIds || []).filter((_, i) => i !== idx);
                            return { ...f, adUnitIds: arr.length ? arr : [''] };
                          })}
                          style={{
                            width: '40px', flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            border: '1px solid ' + (canDelete ? '#fecaca' : '#e2e8f0'),
                            borderRadius: '8px', background: '#fff',
                            color: canDelete ? '#dc2626' : '#cbd5e1',
                            cursor: canDelete ? 'pointer' : 'not-allowed',
                          }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" /></svg>
                        </button>
                      </div>
                    );
                  })}
                </div>
                <div style={C.twoCol}>
                  <div style={C.formGroup}><label style={C.label}>Ad Type</label>
                    <select style={C.input} value={form.adType} onChange={e => {
                      const nextType = e.target.value;
                      // Click Counter is only meaningful for INTERSTITIAL —
                      // clear the value when switching to any other type so
                      // hidden state doesn't leak into the saved record.
                      setForm(f => ({
                        ...f,
                        adType: nextType,
                        position: nextType === 'INTERSTITIAL' ? f.position : '',
                      }));
                    }}>
                      {AD_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                    </select></div>
                  <div style={C.formGroup}><label style={C.label}>Status</label>
                    <select style={C.input} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                      {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select></div>
                </div>
                {form.adType === 'INTERSTITIAL' ? (
                  <div style={C.twoCol}>
                    <div style={C.formGroup}><label style={C.label}>Screen Name *</label>
                      <input style={C.input} value={form.screenName} required
                        onChange={e => setForm(f => ({ ...f, screenName: e.target.value }))} placeholder="HomeScreen" /></div>
                    <div style={C.formGroup}><label style={C.label}>Click Counter</label>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        style={C.input}
                        value={form.position}
                        onChange={e => {
                          const v = e.target.value.replace(/[^0-9]/g, '');
                          setForm(f => ({ ...f, position: v }));
                        }}
                        placeholder="e.g. 5"
                      /></div>
                  </div>
                ) : (
                  <div style={C.formGroup}><label style={C.label}>Screen Name *</label>
                    <input style={C.input} value={form.screenName} required
                      onChange={e => setForm(f => ({ ...f, screenName: e.target.value }))} placeholder="HomeScreen" /></div>
                )}
              </div>
              <div style={C.modalFooter}>
                <button type="button" style={C.secondaryButton} onClick={() => setModal(null)}>Cancel</button>
                <button type="submit" style={C.primaryButton} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

/* ───────────────── Analytics tab ───────────────── */
function AnalyticsTab({ appId }) {
  const today = new Date().toISOString().slice(0, 10);
  const monthAgo = new Date(Date.now() - 30 * 864e5).toISOString().slice(0, 10);
  const [startDate, setStartDate] = useState(monthAgo);
  const [endDate, setEndDate] = useState(today);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true); setErr('');
      const res = await adAnalyticsAPI.getOverview({ applicationId: appId, startDate, endDate });
      setData(res.data || null);
    } catch (e) { setErr(e?.response?.data?.error || 'Failed to load analytics'); }
    finally { setLoading(false); }
  }, [appId, startDate, endDate]);
  useEffect(() => { load(); }, [load]);

  const m = data || {};
  const cards = [
    { label: 'Requests', value: m.totalRequests ?? 0 },
    { label: 'Ads Loaded', value: m.adsLoaded ?? 0 },
    { label: 'Impressions', value: m.impressions ?? 0 },
    { label: 'Fill Rate', value: m.fillRate != null ? `${m.fillRate}%` : '—' },
    { label: 'Show Rate', value: m.showRate != null ? `${m.showRate}%` : '—' },
    { label: 'CTR', value: m.ctr != null ? `${m.ctr}%` : '—' },
    { label: 'Clicks', value: m.adsClicked ?? 0 },
    { label: 'Failed', value: m.adsFailed ?? 0 },
  ];

  return (
    <div style={C.card}>
      <div style={C.dateRow}>
        <label style={C.label}>From</label>
        <input type="date" style={C.dateInput} value={startDate} onChange={e => setStartDate(e.target.value)} />
        <label style={C.label}>To</label>
        <input type="date" style={C.dateInput} value={endDate} onChange={e => setEndDate(e.target.value)} />
      </div>
      {err && <div style={C.errorBox}>{err}</div>}
      {loading ? <div style={C.empty}>Loading…</div> : (
        <div style={C.metricsGrid}>
          {cards.map(c => (
            <div key={c.label} style={C.metric}>
              <div style={C.metricVal}>{c.value}</div>
              <div style={C.metricLbl}>{c.label}</div>
            </div>
          ))}
        </div>
      )}
      <p style={{ fontSize: 12, color: '#94a3b8', padding: '0 16px 16px' }}>
        Metrics are scoped to this application (events → placement → platform).
      </p>
    </div>
  );
}
